// extracted by mini-css-extract-plugin
export var author = "index-module--author--o19sb";
export var authorContainer = "index-module--authorContainer--uKkb3";
export var company = "index-module--company--zTbUk";
export var companyName = "index-module--companyName--p0Ax-";
export var container = "index-module--container--H6tqU";
export var quote = "index-module--quote--D7034";